import { Tracker } from 'services/tracking';
import {
  HOSTED_PAGE_TYPES,
  GA_CATEGORIES,
  GA_LABEL,
  FS_CATEGORIES,
  FS_ACTIONS,
  GA_ACTIONS
} from 'consts';

export const trackOnSubmit = (isFailed = false) => {
  const tracker = new Tracker(HOSTED_PAGE_TYPES.idv);
  tracker.fireEvent({
    category: GA_CATEGORIES.VERIFY_IDV,
    action: GA_CATEGORIES.VERIFY_IDV,
    label: isFailed ? GA_LABEL.FAILURE : GA_LABEL.SUCCESS
  });
};

export const trackOnSecureMeFatalError = error_code => {
  const tracker = new Tracker(HOSTED_PAGE_TYPES.idv);

  tracker.fireEvent(
    {
      category: GA_CATEGORIES.VERIFY_IDV,
      action: GA_ACTIONS.ERROR,
      label: error_code
    },
    {
      category: FS_CATEGORIES.IDV_SECURE,
      action: FS_ACTIONS.FAILURE,
      label: error_code
    }
  );
};
